export const apiConstants = {
  referrersDetails: 'Referral/ReferrersDetails?searchToken=',
};
